import { useEffect, useState } from 'react';
import { getFwvPostEP, getPostData } from '@vfit/consumer/hooks';
import { errorManager, ErrorService } from '@vfit/shared/data-access';
import HiddenPostForm from '../../HiddenPostForm/hiddenPostForm';
import { cleanMsisdn } from './energyContainer.utils';

const EnergyContainer = () => {
  const [postData, setPostData] = useState({
    isEnabled: false,
    url: getFwvPostEP(),
    account: '',
    visitor_id_asset_active: '',
    chk: '',
    nof: '',
    gotocfg: '',
  });

  /*
  setPostData for api call add here the new one 
  */
  const managePostEnrg = (event) => {
    const { detail } = event as CustomEvent as {
      detail: {
        nof?: string;
      };
    };
    // here the function tht retrieve the order getPostData
    const { msisdn, checksum, account } = getPostData?.() || {};
    // const { msisdn, checksum, account, new data added here } = getPostData?.() || {};
    const nof = detail?.nof;
    if (!msisdn || !account) {
      errorManager.handleError(ErrorService.getSeverityErrorHigh(), {
        title: 'Ops',
        message: 'Si è verificato un problema. Riprovare in seguito',
        actionText: 'Chiudi',
        fullscreen: true,
        disableCloseModalOnClickAction: true,
      });
      return;
    }
    setPostData({
      ...postData,
      isEnabled: true,
      ...(account && { account }),
      ...(msisdn && { visitor_id_asset_active: msisdn }),
      ...(checksum && { chk: checksum }),
      ...(nof && { nof }),
      ...(nof && { gotocfg: '1' }),
    });
  };

  const getParams = () => {
    return {
      ...(postData?.account && {
        account: {
          name: 'account',
          value: postData?.account || '',
        },
      }),
      ...(postData?.visitor_id_asset_active && {
        visitor_id_asset_active: {
          name: 'visitor_id_asset_active',
          value: postData?.visitor_id_asset_active || '',
        },
      }),
      ...(postData?.chk && {
        chk: {
          name: 'chk',
          value: postData?.chk || '',
        },
      }),
      ...(postData?.nof && {
        nof: {
          name: 'nof',
          value: postData?.nof || '',
        },
      }),
      ...(postData?.gotocfg && {
        gotocfg: {
          name: 'gotocfg',
          value: postData?.gotocfg || '',
        },
      }),
    };
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('enrgServiceNotificationEvent', managePostEnrg);
    }
    return () => document.removeEventListener('enrgServiceNotificationEvent', managePostEnrg);
  }, []);

  if (!postData?.isEnabled) return;

  return <HiddenPostForm url={postData.url} params={getParams()} />;
};

export default EnergyContainer;

